import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { HomeIcon, ReceiptIcon, PackageIcon, PlusIcon, WalletIcon, UserIcon, LogOutIcon, MenuIcon, GlobeIcon, CheckIcon, ClockIcon, BellIcon, SearchIcon, UploadIcon } from './Icons';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const NavItem = ({ to, icon, label, badge, end, onClick }) => (
  <NavLink to={to} end={end} className={({isActive})=>`nav-item${isActive?' active':''}`} onClick={onClick}>
    <span className="nav-icon">{icon}</span>
    {label}
    {badge != null && badge > 0 && <span className="nav-badge">{badge > 9 ? '9+' : badge}</span>}
  </NavLink>
);

export default function SidebarFornecedor() {
  const navigate = useNavigate();
  const { utilizador, logout } = useAuth();
  const [open,         setOpen]        = useState(false);
  const [naoLidas,     setNaoLidas]    = useState(0);
  const [chatNaoLidas, setChatNaoLidas]= useState(0);
  const close = () => setOpen(false);

  // É cliente com dual-role activado (não é fornecedor nativo)
  const isDualRole = utilizador?.tipo === 'cliente' && utilizador?.pode_fornecer === true;

  useEffect(() => {
    const tk = localStorage.getItem('kialuga_token');
    if (!tk) return;
    fetch(`${BASE}/notificacoes`, { headers: { Authorization: `Bearer ${tk}` } })
      .then(r => r.json())
      .then(d => { if (d.sucesso) setNaoLidas(d.notificacoes.filter(n => !n.lida).length); })
      .catch(() => {});
    fetch(`${BASE}/chat/nao-lidas/count`, { headers: { Authorization: `Bearer ${tk}` } })
      .then(r => r.json())
      .then(d => { if (d.sucesso) setChatNaoLidas(d.nao_lidas); })
      .catch(() => {});
  }, []);

  return (
    <>
      <div className={`sidebar-overlay${open?' show':''}`} onClick={close}/>
      <button className="sidebar-toggle" onClick={()=>setOpen(true)} style={{position:'fixed',top:'8px',left:'12px',zIndex:60}}>
        <MenuIcon size={18}/>
      </button>

      <div className={`sidebar${open?' open':''}`}>
        <div className="sidebar-logo">
          <div className="logo-mark">
            <div className="logo-k">K</div>
            <div>
              <div className="logo-text">KiAluga</div>
              <div className="logo-sub">
                {isDualRole ? 'Modo Fornecedor' : 'Painel do Fornecedor'}
              </div>
            </div>
          </div>
        </div>

        <div className="sidebar-nav">
          <div className="nav-section">Principal</div>
          <NavItem to="/fornecedor"          icon={<HomeIcon    size={16}/>}   label="Visão Geral"      end onClick={close}/>
          <NavItem to="/fornecedor/reservas" icon={<ReceiptIcon size={16}/>}   label="Reservas" badge={chatNaoLidas||undefined} onClick={close}/>
          <NavItem to="/fornecedor/anuncios"    icon={<PackageIcon size={16}/>}  label="Meus Anúncios"    onClick={close}/>
          <NavItem to="/fornecedor/publicar"    icon={<PlusIcon    size={16}/>}  label="Publicar Anúncio" onClick={close}/>
          <NavItem to="/fornecedor/bulk-upload" icon={<UploadIcon  size={16}/>}  label="Publicação em Massa" onClick={close}/>

          <div className="nav-section">Conta</div>
          <NavItem to="/fornecedor/ganhos" icon={<WalletIcon size={16}/>}  label="Saldo & Ganhos"  onClick={close}/>
          <NavItem to="/notificacoes"      icon={<BellIcon   size={16}/>}  label="Notificações" badge={naoLidas} onClick={close}/>
          <NavItem to="/perfil"            icon={<UserIcon   size={16}/>}  label="O meu perfil"    onClick={close}/>
          <div className="nav-item" onClick={()=>{ close(); navigate('/'); }}>
            <span className="nav-icon"><GlobeIcon size={16}/></span> Página inicial
          </div>

          {/* Switch para modo cliente — só aparece em dual-role */}
          {isDualRole && (
            <>
              <div className="nav-section">Modo Cliente</div>
              <div className="nav-item"
                style={{color:'var(--brand-mid)',fontWeight:'600'}}
                onClick={()=>{ close(); navigate('/cliente'); }}>
                <span className="nav-icon"><SearchIcon size={16} color='var(--brand-mid)'/></span>
                Mudar para Cliente
              </div>
            </>
          )}

          <div className="nav-item" style={{color:'rgba(239,68,68,0.7)'}} onClick={()=>{ logout(); navigate('/'); }}>
            <span className="nav-icon"><LogOutIcon size={16}/></span> Sair da conta
          </div>
        </div>

        <div className="sidebar-footer">
          <div className="user-card">
            <div className="avatar" style={{overflow:'hidden'}}>
              {utilizador?.foto_url
                ? <img src={utilizador.foto_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                : (utilizador?.nome||'?')[0].toUpperCase()
              }
            </div>
            <div className="user-info">
              <div className="user-name">{utilizador?.nome||'Fornecedor'}</div>
              <div className="user-role" style={{display:'flex',alignItems:'center',gap:'4px'}}>
                {utilizador?.kyc_estado==='verificado'
                  ? <><CheckIcon size={11} color='var(--success)'/> Verificado</>
                  : <><ClockIcon size={11}/> Pendente KYC</>
                }
                {isDualRole && (
                  <span style={{marginLeft:'4px',fontSize:'9px',background:'var(--brand-mid)',color:'#fff',
                    borderRadius:'4px',padding:'1px 5px',fontWeight:'700',letterSpacing:'0.3px'}}>
                    Dual
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom Navigation (mobile only) ── */}
      <nav className="bottom-nav" aria-label="Navegação do fornecedor">
        <div className="bottom-nav-inner">
          <NavLink to="/fornecedor" end className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <HomeIcon size={22}/>
            <span>Visão Geral</span>
          </NavLink>
          <NavLink to="/fornecedor/reservas" className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <ReceiptIcon size={22}/>
            <span>Reservas</span>
            {chatNaoLidas > 0 && <span className="bottom-nav-badge">{chatNaoLidas > 9 ? '9+' : chatNaoLidas}</span>}
          </NavLink>
          <NavLink to="/fornecedor/anuncios" className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <PackageIcon size={22}/>
            <span>Anúncios</span>
          </NavLink>
          <NavLink to="/fornecedor/publicar" className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <PlusIcon size={22}/>
            <span>Publicar</span>
          </NavLink>
          <NavLink to="/fornecedor/ganhos" className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <WalletIcon size={22}/>
            <span>Ganhos</span>
          </NavLink>
        </div>
      </nav>
    </>
  );
}
